export enum BulkActionEntryState {
  ADDED = 'ADDED',
  REMOVED = 'REMOVED',
  UNCHANGED = 'UNCHANGED',
}
